import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppDispatch } from '../hooks';
import { DebugPanelFrame } from '../DebugPanelFrame';
function useBoolLocalStorage(key) {
    const init = () => {
        var _a;
        return ((_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : '0') == '1';
    };
    const [value, setValueState] = useState(init);
    const setValue = (v) => {
        setValueState(v);
        localStorage.setItem(key, v ? '1' : '0');
    };
    return [value, setValue];
}
const LocalStorageCheckbox = (props) => {
    const [value, setValue] = useBoolLocalStorage(props.name);
    return (_jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: value, onChange: e => setValue(e.target.checked) }), "\u00A0", props.name] }));
};
const outputState = (dispatch, getState) => {
    const s = getState();
    console.log(s);
};
const outputDefinitions = (dispatch, getState) => {
    const s = getState();
    console.log(s.definitions);
};
export const DebugPanel = () => {
    const dispatch = useAppDispatch();
    return (_jsxs(DebugPanelFrame, { children: [_jsx(LocalStorageCheckbox, { name: "log_device_state_changes" }), _jsx("br", {}), _jsx(LocalStorageCheckbox, { name: "log_event_definitions" }), _jsx("br", {}), _jsx(LocalStorageCheckbox, { name: "log_event_device_states" }), _jsx("br", {}), _jsx(LocalStorageCheckbox, { name: "log_event_entity_states" }), _jsx("br", {}), _jsx(LocalStorageCheckbox, { name: "log_event_zigbee_attributes" }), _jsx("br", {}), _jsx(LocalStorageCheckbox, { name: "log_redux_state_changes" }), _jsx("hr", {}), _jsx("button", { onClick: () => dispatch(outputDefinitions), children: "Output definitions" }), "\u00A0", _jsx("button", { onClick: () => dispatch(outputState), children: "Output state" })] }));
};
